// Constant for keyboard transition.
export default Object.freeze({ duration: 500, timingFunction: 'ease-in-out' });
//# sourceMappingURL=KeyboardTransition.js.map